import { TEN_SECONDS } from '~/shared/constants/time'

export const RewindTypes = {
  dvr: 'dvr',
  timeshift: 'timeshift',
  rewind: 'rewind',
} as const
export type RewindTypes = (typeof RewindTypes)[keyof typeof RewindTypes]

// priority ordered
export const REWIND_TYPES_WITHOUT_EPG = [
  RewindTypes.rewind,
  RewindTypes.dvr,
  RewindTypes.timeshift,
]

// priority ordered
export const REWIND_TYPES_WITH_EPG = [
  RewindTypes.dvr,
  RewindTypes.timeshift,
  RewindTypes.rewind,
]

// priority ordered
export const REWIND_TYPES_EVENT = [
  RewindTypes.dvr,
  RewindTypes.timeshift,
  RewindTypes.rewind,
]

export const ONE_STEP_REWIND_SEC = TEN_SECONDS
